import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { setSessionStorage } from '@src/services/sessionStorage';
import { UTM_PARAMS } from '@src/constants/utm';

/**
 * Hook to store UTM_PARAMS in sessionStorage
 */
export const useStoreUtmParams = () => {
  const router = useRouter();

  useEffect(() => {
    // get utmParams from router
    const { utm_source, utm_medium, utm_campaign, utm_content } = router.query;
    // Create an object with the defined utmParams
    const utmParams = {
      ...(utm_source && { utm_source }),
      ...(utm_medium && { utm_medium }),
      ...(utm_campaign && { utm_campaign }),
      ...(utm_content && { utm_content })
    };

    // Check if there is at least one utmParam defined
    const hasAnyUtmParams = Object.keys(utmParams).length > 0;

    // set UTM_PARAMS in sessionStorage
    if (hasAnyUtmParams) {
      setSessionStorage(UTM_PARAMS, JSON.stringify(utmParams));
    }
  }, [router.query]);
};
